// extracted by mini-css-extract-plugin
export default {"mainContainer":"List__mainContainer___HHBpd","listContainer":"List__listContainer___n3nlC"};